import "./App.css";
import { Route, Routes, Navigate } from "react-router";
import { App, ColorPicker, ConfigProvider, Radio, Space } from "antd";
import { HashRouter } from "react-router-dom";
import {TEMPERATURE_DASHBOARD} from "./Common/Constants";
import LiveChart from "./components/Screens/Electrical/Charts/LiveModule/LiveTrends/LineChart/LiveChart";
import MeterStatus from "./components/Screens/Electrical/Charts/LiveModule/MeterStatus/MeterStatus";
import {TempItems,TempNavItems} from "./components/Elements/NavRoutes";
import SidebarLayout from "./components/CommonScreens/SidebarLayout";
import ParameterView from "./components/Screens/Electrical/Charts/LiveModule/ParameterView/ParameterView";
import TempLiveChart from "./components/Screens/Temperature/TemperatureModule/TempLiveModule/TempLiveTrends/TempLineChart/TempLiveChart";
import TempConvertorStatus from "./components/Screens/Temperature/TemperatureModule/TempLiveModule/TempLiveTrends/TempGaugeCard/TempConvertorStatus";

import TempRawDataGrid from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempRawData/TempRawDataGrid";
import TempHistoricalTrends from "./components/Screens/Temperature/TemperatureModule/HistoricalReports/TempHistoricalTrends/TempHistoricalTrends";
import ComparitiveReport from "./components/Screens/Electrical/Charts/HistoricalReports/ComparativeReport/ComparativeRepot";
import ConsumptionReportElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/ConsumptionReport/ConsumptionReportElectrical";
import RawDataElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/RawData/RawDataGrid/RawData";
import { useDispatch, useSelector } from "react-redux";
import ElectricalHistoricalTrends from "./components/Screens/Electrical/Charts/HistoricalReports/HistoricalTrends/ElectrialHistoricalTrends";

import CustomThemeDrawer from "./components/Elements/CustomThemeDrawer.jsx";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { setCustomTheme, setTheme } from "./Store/Reducers/ThemeAction.jsx";
import { handledarkMode } from "./components/Elements/DarkModeAction.jsx";
import { useState } from "react";
import StatusView from "./components/Screens/Electrical/Charts/LiveModule/Manual Entry/StatusView.jsx";

import PlotInterval from "./components/Screens/Electrical/Charts/LiveModule/PlotInterval/PlotInterval.jsx";
import GroupConfiguration from "./components/Screens/Electrical/Charts/GroupConfiguration/GroupConfiguration.jsx";
import GroupReport from "./components/Screens/Electrical/Charts/GroupReport/GroupReport.jsx";
import ShiftReportFlow from "./components/Screens/ShiftReport/ShiftReport.jsx";


export default function Router() {
  const loggedIn = useSelector((state) => state.user.login);
  // console.log(loggedIn)
  const [openTheme, setOpenTheme] = useState(false);
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  // console.log(color)
  const [color1, setColor1] = useState("#3498db");
  const { isdarkMode } = mode;

  const dispatch = useDispatch();
  const [selectedTheme, setSelectedTheme] = useState("green");
  const handleChange = (e) => {
    dispatch(setTheme(e.target.value));
    setSelectedTheme(e.target.value);
  };
  const switchDarkMode = () => {
    isdarkMode
      ? dispatch(handledarkMode(false))
      : dispatch(handledarkMode(true));
  };
  const showThemeDrawer = () => {
    setOpenTheme(true);
  };

  const onThemeClose = () => {
    setOpenTheme(false);
  };

  const handleColorChange = (colorResult) => {
    const hex = colorResult.toHexString(); // Convert to hex string
    setColor1(hex);
    dispatch(setCustomTheme(hex));
    setSelectedTheme("Custom");
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: color.themeConfig.colorPrimary,
          colorPrimaryHover: color.themeConfig.colorPrimaryHover,
        },
        components: {
          Button: {
            colorPrimary: color.themeConfig.colorPrimary,
            colorPrimaryHover: color.themeConfig.colorPrimaryHover,
            colorPrimaryActive: color.themeConfig.colorPrimaryHover,
          },
          Input: {
            activeBorderColor: color.themeConfig.colorPrimary,
            hoverBorderColor: color.themeConfig.colorPrimary,
          },
          Modal: {
            colorPrimary: color.themeConfig.colorPrimary,
          },
          DatePicker: {
            colorPrimary: color.themeConfig.colorPrimary,
            colorPrimaryHover: color.themeConfig.colorPrimaryHover,
          },
          RangePicker: {
            colorPrimary: color.themeConfig.colorPrimary,
            colorPrimaryHover: color.themeConfig.colorPrimaryHover,
          },
          Table: {
            headerBg: color.themeConfig.colorPrimary, // Header background color
            headerColor: "#fff", // Header text color
            rowHoverBg: color.themeConfig.colorPrimaryHover, // Row hover effect
            colorBorderSecondary: color.themeConfig.colorPrimary, // Border color
            colorBgContainer: isdarkMode === "dark" ? "#292c35" : "#fff", // Background color for dark mode
          },
        },
      }}
    >
      <App className="overflow-hidden">
        <HashRouter>
          <Routes>
            {/* <Route path={LOGIN} element={<LoginForm/>}/> */}
            {/* <Route path={LOGIN} element={<LoginForm2 />} /> */}
            {/* <Route path={LANDING+ "/"} element={<LandingPage/>}/> */}
            {/* <Route path={SIGNUP} element={<SignUpForm />} /> */}
            {/* <Route path={UNAUTHORIZED_PATH} element={<NotAuthenticated />} /> */}
           

            {/* Temperature layout */}
             <Route
              path="/"
              element={<Navigate to={TEMPERATURE_DASHBOARD + "/status-view"} replace />}
            />
            <Route 
              path={TEMPERATURE_DASHBOARD + "/*"}
              element={
                  <SidebarLayout
                    title={"Temperature"}
                    items={TempItems}
                    NavItems={TempNavItems}  
                    DefaultRoute={<StatusView />}
                  />
              }
            >
              <Route path="status-view" element={<StatusView />} />
              <Route index path="live-trends" element={<LiveChart />} />
              <Route path="meter-status" element={<MeterStatus />}>
                <Route path="meter-status-popup" element={<MeterStatus />} />
              </Route>
              <Route path="parameter-view" element={<ParameterView />} />
              <Route path="comparative-report" element={<ComparitiveReport />}/>
              <Route path="configuration-group" element={<GroupConfiguration />} />
              <Route path="raw-data" element={<RawDataElectrical />} />
              <Route path="historical-trends" element={<ElectricalHistoricalTrends />}
              />
              <Route path="consumption-report" element={<ConsumptionReportElectrical />}/>

              <Route path="live-trends" element={<TempLiveChart />} />
              <Route path="plot-report" element={<PlotInterval />} />
              <Route path="group-report" element={<GroupReport />} />
              <Route path="shift-report" element={<ShiftReportFlow/>} />
              {/* <Route path="meter-status" element={<TempMeterStatus />}>
                <Route
                  path="meter-status-popup"
                  element={<TempMeterStatus />}
                />
              </Route> */}
              <Route path="convertor-status" element={<TempConvertorStatus />} >
                <Route
                  path="convertor-status-popup"
                  element={<TempConvertorStatus />}
                />
              </Route>

              {/* <Route 
                    path="temp-comparative-report" 
                    element={<TempComparativeReport />} 
                  /> */}
              <Route path="temp-raw-data" element={<TempRawDataGrid />} />
              <Route
                path="temp-historical-trends"
                element={<TempHistoricalTrends />}
              />
              {/* <Route 
                    path="temp-consumption-report"
                    element={<TempConsumptionReport />}
                  /> */}
            </Route>

            {/* <Route path={AR_NO_MATCH} element={<Navigate to={LOGIN} />} /> */}
            {/* <Route path={UNAUTHORIZED_PATH} element={<Navigate to={LOGIN} />} /> */}
          </Routes>
        </HashRouter>
      </App>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showThemeDrawer}
        open={openTheme}
        onClose={onThemeClose}
      >
        <div className="flex flex-col space-y-2">
          <div className=" mb-3">
            <div
              className={` text-lg  w-fit mb-1  ${
                isdarkMode
                  ? " text-white border-gray-400"
                  : "text-black border-white"
              }`}
            >
              Select Primary Color
            </div>
            <Radio.Group
              buttonStyle="solid"
              onChange={handleChange}
              value={selectedTheme}
            >
              <Space className="flex flex-wrap w-full text-white pl-0 pb-4">
                <Radio.Button
                  value="green"
                  className={` !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  Green
                </Radio.Button>
                <Radio.Button
                  value="blue"
                  className={` !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  Blue
                </Radio.Button>

                <Radio.Button
                  value="red"
                  className={` !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  Red
                </Radio.Button>
                <Radio.Button
                  value="purple"
                  className={` !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  Purple
                </Radio.Button>
              </Space>

              <div
                className={` text-lg  w-fit mb-1  ${
                  isdarkMode
                    ? " text-white border-gray-400"
                    : "text-black border-white"
                }`}
              >
                Select Custom Color
              </div>
              <ColorPicker
                defaultValue="#1677ff"
                size="large"
                onChange={handleColorChange}
                showText
              />

              <div className="text-xs text-gray-500 mt-2">
                *Click on the color to select
              </div>
            </Radio.Group>
          </div>
          <div className=" mb-3">
            <div
              className={` text-lg w-fit mb-1  ${
                isdarkMode
                  ? " text-white border-gray-400"
                  : "text-black border-white"
              }`}
            >
              Select Theme
            </div>
            <Radio.Group
              size="large"
              buttonStyle="solid"
              onChange={switchDarkMode}
              value={selectedTheme}
            >
              <Space className="flex flex-wrap w-full text-2xl text-white pl-0 pb-4">
                <Radio.Button
                  value="light"
                  className={` !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  <SunOutlined className="mx-5" />
                </Radio.Button>
                <Radio.Button
                  value="dark"
                  className={`  !rounded-md ${
                    isdarkMode
                      ? "bg-gray-800 text-white border-white"
                      : "text-black"
                  }`}
                >
                  <MoonOutlined className=" mx-5" />
                </Radio.Button>
              </Space>
            </Radio.Group>
          </div>
        </div>
        {/* <div className="flex justify-center mt-4">
                            <Button
                              type= {isdarkMode? "":'primary'}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Search
                            </Button>
              </div> */}
      </CustomThemeDrawer>
    </ConfigProvider>
  );
}

//  <Route
//               path={CONFIGURATION_DASHBOARD + "/*"}
//               element={ <PrivateRoutes>
//                 <SidebarLayout
//                   NavItems={ConfigurationNavItems}
//                   items={ConfigurationItems}
//                   title={'Configuration'}
//                   DefaultRoute={<DashConverters />}
//                 />
//               </PrivateRoutes>
//             }
//             >

//               <Route path="Converter-config" element={<ConverterConfiguration />}>
//                 <Route path="converter-add-popup" element={<ConverterConfiguration />} />
//               </Route>
//               <Route path="Device-config" element={<DeviceConfiguration />}>
//                 <Route path="device-add-popup" element={<DeviceConfiguration />} />
//               </Route>
//               <Route path="User-registration" element={<UserRegistration />}>
//                 <Route path="user-add-popup" element={<UserRegistration />} />
//               </Route>
//               <Route path="Manual-Entry" element={<ManualEntry />}>
//                 <Route path="manual-entry-add-popup" element={<ManualEntry />} />
//               </Route>

//               <Route path="Emission-Factor" element={<EmissionFactor />}>
//                 <Route path="emission-factor-add-popup" element={<EmissionFactor />} />
//               </Route>

//             <Route path="converters-meters" element={<DashConverters />} />
//             <Route path="configuration-live" element={<DashLive />} />
//             <Route path="configuration-energy" element={<DashEnergy />} />
//             <Route path="configuration-groups" element={<GroupConfiguration />} />
//             <Route path="configuration-roles" element={<UserRoles />} />
//             <Route path="configuration-user-registration" element={<UserRegister />} />
//             <Route path="configuration-screens" element={<ScreenConfiguration />} />

//               <Route path="Group-config/group" element={<Groups />}>
//                 <Route path="group-add-popup" element={<Groups />} />
//                 <Route path="group-update-popup" element={<Groups />} />
//               </Route>

//               <Route path="Group-config/sub-group" element={<SubGroup />}>
//                 <Route path="sub-group-add-popup" element={<SubGroup />} />
//                 <Route path="sub-group-update-popup" element={<SubGroup />} />

//               </Route>

//               <Route path="Group-config/group-meter" element={<GroupMeterConfig />}>
//                 <Route path="group-meter-add-popup" element={<GroupMeterConfig />} />
//                 <Route path="group-meter-update-popup" element={<GroupMeterConfig />} />
//               </Route>

//               {/* <Route path="Steam-grouping/group" element={<SteamGroup />}>
//                 <Route path="group-add-popup" element={<SteamGroup />} />
//                 <Route path="group-update-popup" element={<SteamGroup />} />
//               </Route>

//               <Route path="Steam-grouping/sub-group" element={<SteamSubGroup />}>
//                 <Route path="sub-group-add-popup" element={<SteamSubGroup />} />
//                 <Route path="sub-group-update-popup" element={<SteamSubGroup />} />
//               </Route>

//               <Route path="Steam-grouping/group-meter" element={<SteamGroupMeter />}>
//                 <Route path="group-meter-add-popup" element={<SteamGroupMeter />} />
//                 <Route path="group-meter-update-popup" element={<SteamGroupMeter />} />
//               </Route>

//               <Route path="Water-grouping/group" element={<WaterGroup />}>
//                 <Route path="group-add-popup" element={<WaterGroup />} />
//                 <Route path="group-update-popup" element={<WaterGroup />} />
//               </Route>

//               <Route path="Water-grouping/sub-group" element={<WaterSubGroup />}>
//                 <Route path="sub-group-add-popup" element={<WaterSubGroup />} />
//                 <Route path="sub-group-update-popup" element={<WaterSubGroup />} />
//               </Route>

//               <Route path="Water-grouping/group-meter" element={<WaterGroupMeter />}>
//                 <Route path="group-meter-add-popup" element={< WaterGroupMeter/>} />
//                 <Route path="group-meter-update-popup" element={<WaterGroupMeter />} />
//               </Route> */}

//             </Route>
